export const SITE = process.env.NEXT_PUBLIC_SITE || 'default';

/** App in 'development' environment */
export const IS_DEV = process.env.NODE_ENV === 'development';

export const DISABLE_CACHE = IS_DEV && process.env.NEXT_PUBLIC_DISABLE_CACHE === 'true';

export const LOCAL_TZ = process.env.NEXT_PUBLIC_TZ || 'Australia/Melbourne';
export const LOCALE = process.env.NEXT_PUBLIC_LOCALE ?? 'en-AU';
export const I18N_DEFAULT_LOCALE = 'en';

export enum IMG_RATIO {
  SQUARE = 1,
  PORTRAIT = 1.42, // 3:2
  LANDSCAPE = 496 / 744, // 0.715,
  LANDSCAPE_TALL = 0.8, // ~4:3
  LANDSCAPE_WIDE = 0.54, // 16:9
  VIDEO = 0.5625, // 16:9
}

export type ImgRatios = typeof IMG_RATIO;
export type ImgRatio = keyof ImgRatios;

// Entry type URI settings

export const ENTRY_TYPE_URI_SETTINGS = {
  eventIndex: 'events',
  articleIndex: 'article',
} as const;

export const SEARCHABLE_ENTRY_TYPES = ['article', 'event', 'page'];

export const UPDATE_EVENT_API_ROUTE = '/api/vt/event';
export const UPDATE_EVENT_TIME_API_ROUTE = '/api/vt/event-time';

/** Must match `crons[].path` in `frontend/vercel.json`. Trailing slash required when `next.config` has `trailingSlash: true`. */
export const CRON_VIVATICKET_SYNC_PATH = '/api/cron/vivaticket/';

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export const VIVATICKET_URL = process.env.NEXT_PUBLIC_VIVATICKET_URL;
